import React, { useRef } from 'react';
import { useStep } from '../../hooks/useStep';
import { trail } from 'light-trails';
export const Animate = props => {
  const anim = props.anim,
        exitAnim = props.exitAnim;
  const ref = useRef(null);
  useStep(props.in, () => trail(ref.current, anim), {
    title: '→Animate'
  });
  const hasExit = exitAnim && props.out;
  useStep(hasExit ? props.out : undefined, () => trail(ref.current, exitAnim), {
    title: '←Animate'
  });
  return React.createElement("div", {
    ref: ref
  }, props.children);
};